<template>
    <div class="view-content view5">
        <div class="title">{{ $t('核心特性') }}</div>
        <div class="ul">
            <div class="li-box" v-for="(item, index) in list" :key="index">
                <div class="li">
                    <div class="li-img-box"><img class="li-img" :src="item.img" /></div>
                    <div class="text-box">
                        <div class="li-title">{{ item.title }}</div>
                        <div class="li-text">{{ item.text }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'view5',
  data () {
    return {
        list: [
            {
                img: require('./img/1030/view5-1.png'),
                title: this.$t('链上结算'),
                text: this.$t('每笔电商交易 0.2 秒确认，安全透明'),
            },
            {
                img: require('./img/1030/view5-2.png'),
                title: this.$t('激励协议'),
                text: this.$t('激励消费者、商家、渠道等为NECO做出贡献'),
            },
            {
                img: require('./img/1030/view5-3.png'),
                title: this.$t('权益积分'),
                text: this.$t('用户消费即持有可追踪、可变现的权益积分'),
            },
            {
                img: require('./img/1030/view5-4.png'),
                title: this.$t('共建共享'),
                text: this.$t('首个去中心商业自治组织，共建共享NECO电商'),
            },
        ]
    }
  },
}
</script>

<style scoped>
@import "./css/index.css";
.view5 {
    flex-direction: column;
    justify-content: center;

}

.view5 .ul {
    padding-top: 125px;
    flex-shrink: 0;
    align-self: stretch;
}

.view5 .li-box {
    padding-right: 45px;
    box-sizing: border-box;
    flex: 1;
    align-self: stretch;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.view5 .li-box:last-child {
    padding-right: 0;
}

.view5 .li {
    border-radius: 10px;
    padding: 15px 22px 20px 0;
    border: 1px solid rgba(255, 255, 255, 0.50);
    background: linear-gradient(180deg, rgba(0, 255, 30, 0.00) 0.01%, rgba(0, 255, 30, 0.00) 47.12%, rgba(0, 255, 30, 0.50) 100%);
    
}

.view5 .li-img-box {
    justify-content: flex-start;
    height: auto;
}

.view5 .li-img {
    width: 128px;
}

.text-box {
    padding: 67px 0 0 24px;
    text-align: left;
}

.view5 .li-title {
    font-size: 24px;
    font-weight: 600;
}
.view5 .li-text {
    font-size: 16px;
    font-weight: 600;
}

@media screen and (max-width: 768px) {
    .view5 .li-img-box {
        width: 80px;
        height: 80px;
        align-items: center;
        padding-bottom: 0;
    }
    .view5 ul {
        display: block;
    }
    .view5 .li {
        margin-bottom: .2rem;
        display: flex;
        align-items: center;
    }
    .view5 .li-box {
        width: 100%;
        padding-right: 0;

    }
    .view5 .li-img {
        width: 100%;
        height: 100%;
        margin-bottom: 0;
    }
    .text-box {
        flex: 1;
        box-sizing: border-box;
        padding: 0 0 0 6px;
    }
    .view5 .li-title {
        font-size: 18px;
    }
    .view5 .li-text {
        font-size: 14px;
        padding-top: 6px;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/lobby/components1030/view5.vue